export enum CustomOrderType {
  COLLECT_AT_STORE = 'COLLECT_AT_STORE',
  HOME_DELIVERY = 'HOME_DELIVERY'
}
